<template>
  <div v-if="visible" class="page-loader">
    <div class="loader-container">
      <img :src="logoUrl" alt="Loading" class="loader-logo" />
      <div class="loader-spinner"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, defineProps } from "vue";

defineProps({
  logoUrl: {
    type: String,
    required: true,
  },
});

const visible = ref(true);

onMounted(() => {
  // Display loader for 4 seconds
  setTimeout(() => {
    visible.value = false;
  }, 3000);
});
</script>

<style scoped>
.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeOut 0.5s ease 3.5s forwards;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.loader-logo {
  width: 17rem;
  height: 17rem;
  object-fit: contain;
  animation: pulse 2s infinite;
}

.loader-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(160, 123, 51, 0.2);
  border-top: 4px solid #a07b33;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
}
</style>
